module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-cannot-i-use-vux-with-cdn-22.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/why-cannot-i-use-vux-with-cdn.md
// module id = 598
// module chunks = 185